import AsyncStorage from '@react-native-async-storage/async-storage';
import { clientConfigPath } from '../../config/Constant';
import { setAdhocWidgetData, setRenderAdhoc } from '../Reducers/adhocReducer';


export const HOMEPAGE = "homepage";
export const BEFORE_PRE_CHECK_IN = "beforePreCheckIn"

export const TRIGGER_CATEGORY_MAP = {
    PRE_CHECK_IN: [BEFORE_PRE_CHECK_IN, HOMEPAGE]
};

const ADHOC_WIDGET_DEFAULT_SHAPE = {
    [HOMEPAGE]: [],
    [BEFORE_PRE_CHECK_IN]: []
};

let isFetchingAdhoc = false;

function adjustToHotelGMTOffset(dateString, offset) {
    const date = new Date(dateString);
    date.setUTCHours(date.getUTCHours() + offset.hours);
    date.setUTCMinutes(date.getUTCMinutes() + offset.minutes);
    return date;
}


const groupAdhocEventByCategory = (event, result = {}, category) => {
    if (!event) return;

    const pushToCategory = (key) => {
        (result[key] ||= []).push(event);
    };

    if (category) {
        pushToCategory(category);
        return;
    }

    const type = event?.type;
    if (!type) return;

    const pageKeys = TRIGGER_CATEGORY_MAP[type];

    if (!pageKeys?.length) {
        pushToCategory(HOMEPAGE);
        return;
    }

    pageKeys.forEach((key) => {
        pushToCategory(
            ADHOC_WIDGET_DEFAULT_SHAPE[key] ? key : HOMEPAGE
        );
    });
};

const checkShowAdhoc = (dataList) => {

    return async (dispatch, getState) => {

        const state = getState();

        const { isLoggedIn } = state.appConfigSlice;
        const { currentGuestDetails } = state.guestDetailsSlice;
        const checkInguestInfo = currentGuestDetails?.reservationNumber ? currentGuestDetails : null;

        const { isBookingFound } = state.checkInSlice.bookingStatus;
        const { preCheckInCompleted } = state.checkInSlice.preCheckInStatus

        const serverTimeDataObj = state.serverDateTimeSlice.serverTimeDataObj;
        const serverDateTime = serverTimeDataObj.date ? new Date(serverTimeDataObj.date) : new Date();
        const serverDate = new Date(serverDateTime).setHours(0, 0, 0, 0);
        const todayDate = serverTimeDataObj.date ? new Date(serverTimeDataObj.date.split('T')[0] + 'T00:00:00') : new Date();
        const currentDay = serverTimeDataObj.currentDay?.toLowerCase() || '';

        const supportedAdHocList = ['Pop-up Message', 'Image', 'Native notification (mobile)', 'Upsell', 'Scheduled Message'];




        const adHocEventShownIDListStr = await AsyncStorage.getItem('adHocEventShownIDList');
        const adHocEventShownIDList = JSON.parse(adHocEventShownIDListStr) || [];

        const isValidForPopup = (eventData) => {
            for (const shownAdHocData of adHocEventShownIDList) {
                if (shownAdHocData.id === eventData.id && shownAdHocData.triggerType == eventData.type) {
                    // shown on a previous day — re-eligible only if it's a weekday-recurring event
                    if (new Date(shownAdHocData.adhocEventShownDate) < serverDate) {
                        return currentDay && eventData.adhocEventWeekDay && Object.keys(eventData.adhocEventWeekDay).length > 0 && !!eventData.adhocEventWeekDay[currentDay];
                    }
                    return false; // shown today already
                }
            }
            return true;
        };

        const isValidForToday = (eventData) => {
            if(!eventData.adhocEventWeekDay || !Object.keys(eventData.adhocEventWeekDay).length) return true;

            return currentDay && eventData.adhocEventWeekDay && Object.keys(eventData.adhocEventWeekDay).length > 0 && !!eventData.adhocEventWeekDay[currentDay];
        };


        const adHocPopupList = [];
        const adHocWidgetList = [];

        dataList.forEach((adhocEventsData) => {

            // Expand by trigger types
            const expandedEvents = [];
            if (adhocEventsData.adhocTriggers && adhocEventsData.adhocTriggers.length > 0) {
                adhocEventsData.adhocTriggers.forEach((triggerTypeData) => {
                    expandedEvents.push({ ...adhocEventsData, type: triggerTypeData.triggerType });
                });
            } else {
                expandedEvents.push(adhocEventsData);
            }

            expandedEvents.forEach((rawEvent) => {

                // Skip unsupported types before parsing extraParams
                if (!supportedAdHocList.includes(rawEvent.multimediaType)) return;

                const adHocEvent = { ...rawEvent, extraParams: JSON.parse(rawEvent.extraParams) };

                const adHocEventStartTime = adjustToHotelGMTOffset(adHocEvent.startDate, serverTimeDataObj.gmtOffset);
                const adhocEventEndTime = adjustToHotelGMTOffset(adHocEvent.endDate, serverTimeDataObj.gmtOffset);

                if (adHocEventStartTime <= serverDateTime && serverDateTime <= adhocEventEndTime) {

                    // Resolve the effective "show time" for TIME-based extraParam
                    const resolveShowTime = (requiredDate) => {
                        const adHocEventShowTime = requiredDate
                            ? requiredDate
                            : (adHocEvent.adhocEventWeekDay && Object.keys(adHocEvent.adhocEventWeekDay).length > 0)
                                ? new Date(serverDateTime)
                                : new Date(adHocEventStartTime);

                        if (adHocEvent.extraParams?.TIME) {
                            const [hours, minutes] = adHocEvent.extraParams.TIME.split(':');
                            adHocEventShowTime.setHours(hours, minutes, 0, 0);

                            return serverDateTime >= adHocEventShowTime ? true : false;
                        }
                        return true;
                    };

                    const resolveShowDay = () => {
                        if (currentDay && adHocEvent.adhocEventWeekDay && Object.keys(adHocEvent.adhocEventWeekDay).length > 0 && !adHocEvent.adhocEventWeekDay[currentDay]) {
                            return false;
                        }
                        return true;
                    };

                    // Push to both lists if event passes time/guest-state conditions
                    const tryPush = (requiredDate) => {
                        const checkShowTime = resolveShowTime(requiredDate);

                        if (checkShowTime) {
                            const checkShowDay = resolveShowDay()

                            if(checkShowDay){
                                if(isValidForToday(adHocEvent)){
                                    adHocWidgetList.push(adHocEvent)
                                }

                                const ifIsValidForPopup = isValidForPopup(adHocEvent)
                                if(ifIsValidForPopup){
                                    adHocPopupList.push(adHocEvent)
                                }
                            }
                        }
                    };
                    if(adHocEvent.multimediaType == "Upsell"){
                        const filterQualityPlusRequestList = adHocEvent.qualityPlusRequestList?.filter((q) => !q.isRequested);
                        adHocEvent.qualityPlusRequestList = filterQualityPlusRequestList;
                        
                        if(!filterQualityPlusRequestList?.length){
                            return
                        }
                    }


                    if (adHocEvent.type == 'Date' || adHocEvent.type == 'OTHERS') {
                        tryPush(null);
                    } else if (adHocEvent.type == 'PRE_CHECK_IN' && (isBookingFound && !isLoggedIn)) {
                        tryPush(null);
                    } else if (adHocEvent.type == 'POST_PRE_CHECK_IN' && (preCheckInCompleted && !isLoggedIn)) {
                        tryPush(null);
                    } else if (adHocEvent.type == 'GUEST_STAY' && isLoggedIn) {
                        tryPush(null);
                    } else if (adHocEvent.type == 'POST_CHECK_IN' && isLoggedIn) {

                        if (checkInguestInfo?.checkInDate) {
                            const adHocMessageShowDate = new Date(checkInguestInfo.checkInDate.split('T')[0] + 'T00:00:00');
                            adHocMessageShowDate.setTime(adHocMessageShowDate.getTime() + ((adHocEvent.extraParams.NO_OF_DAYS || 0) * 24 * 60 * 60 * 1000));
                            tryPush(adHocMessageShowDate);
                        }

                    } else if (adHocEvent.type == 'PRE_CHECK_OUT' && isLoggedIn) {

                        if (checkInguestInfo?.plannedCheckOutDate) {
                            const adHocMessageShowDate = new Date(checkInguestInfo.plannedCheckOutDate.split('T')[0] + 'T00:00:00');
                            adHocMessageShowDate.setTime(adHocMessageShowDate.getTime() - ((adHocEvent.extraParams.NO_OF_DAYS || 0) * 24 * 60 * 60 * 1000));
                            if (serverDateTime >= adHocMessageShowDate) tryPush(adHocMessageShowDate);
                        }

                    } else if (adHocEvent.type == 'BIRTHDAY' && isLoggedIn) {
                        if (checkInguestInfo?.guestProfile?.birthday) {
                            const adHocMessageShowDate = new Date(checkInguestInfo.guestProfile.birthday.split('T')[0] + 'T00:00:00');
                            if (todayDate.getTime() === adHocMessageShowDate.getTime()) tryPush(adHocMessageShowDate);
                        }
                    }
                }
            });
        });

        // Always update widget data so guests can browse anytime
        const sorted = adHocWidgetList.sort((a, b) => a.priority - b.priority);
        const adhocGroupedList = {};
        sorted.forEach((event) => {
            groupAdhocEventByCategory(event, adhocGroupedList);
        })

        dispatch(setAdhocWidgetData(adhocGroupedList));

        // Only trigger popup for events not yet seen today
        if(adHocPopupList.length > 0 && (preCheckInCompleted || isLoggedIn)){
            dispatch(setRenderAdhoc({
                showAdhoc: true,
                adhocData: adHocPopupList.sort((a, b) => a.priority - b.priority),
            }));
        }
    }
};

export const fetchAdhoc = () => {
    return async (dispatch, getState) => {

        if (isFetchingAdhoc) return;
        isFetchingAdhoc = true;
        setTimeout(() => { isFetchingAdhoc = false; }, 3000);


        const state = getState();
        const activeUpsellType = state.deviceConfigSlice?.webAppWidgetsInfo?.activeUpsellType;

        if(activeUpsellType === "NOR1"){
            await dispatch(fetchAdhocNor1());
            isFetchingAdhoc = false;
            return
        }


        try {

            const { appSessionToken, isLoggedIn } = state.appConfigSlice;
            const { currentGuestDetails } = state.guestDetailsSlice;
            const { isBookingFound, bookingData } = state.checkInSlice.bookingStatus;

            let reservationNumber = null;
            if (isLoggedIn) {
                reservationNumber = currentGuestDetails.reservationNumber;
            } else if (isBookingFound) {
                reservationNumber = bookingData.reservationNumber;
            }

            const response = await clientConfigPath.post('/adhocEvents/fetch', {
                header: {
                    sessionToken: appSessionToken,
                    reservationNumber: reservationNumber || null,
                },
            });

            const adhocEventList = response.data?.payload?.adhocEventList || [];

            dispatch(checkShowAdhoc(adhocEventList));

        } catch (error) {
            console.log('Adhoc fetching error', error);
        } finally {
            isFetchingAdhoc = false;
        }
    };
};

export const fetchAdhocNor1 = () => {
    return async (dispatch, getState) => {
        try {
            // const response = {
            //     "class": "com.hoteligence.connector.utils.ResponseWrapper",
            //     "header": {
            //         "status": {
            //             "code": "SUCCESS",
            //             "msg": "Request Successfull"
            //         }
            //     },
            //     "payload": {
            //         "reservationId": "365256",
            //         "provider": "NOR1",
            //         "responseCode": 200,
            //         "errorMessage": "",
            //         "data": {
            //             "items": [
            //                 {
            //                     "upsellOffers": [
            //                         {
            //                             "offerType": "room_upgrade",
            //                             "selectionType": "zero_to_one",
            //                             "offers": [
            //                                 {
            //                                     "roomTypeCode": [
            //                                         "STA"
            //                                     ],
            //                                     "price": {
            //                                         "amount": 6,
            //                                         "currency": "USD"
            //                                     },
            //                                     "chargeFrequency": "per_unit_per_night",
            //                                     "fixedCharge": 18,
            //                                     "description": "<ul>\r\n<li>Extra Large TV</li>\r\n<li>Ocean View</li>\r\n<li>Balcony</li>\r\n</ul>",
            //                                     "name": "Standard Room",
            //                                     "images": {
            //                                         "big": "https://cdn1.oci.nor1uat.com/room-images/h-1214/009223/big/00142247.jpg",
            //                                         "small": "https://cdn1.oci.nor1uat.com/room-images/h-1214/009223/small/00142247.jpg"
            //                                     },
            //                                     "savings": 4,
            //                                     "offerId": "6263FB24-294A-4D85-BBB7-55A9B49392F7"
            //                                 },
            //                                 {
            //                                     "roomTypeCode": [
            //                                         "DEL"
            //                                     ],
            //                                     "price": {
            //                                         "amount": 13.28,
            //                                         "currency": "USD"
            //                                     },
            //                                     "chargeFrequency": "per_unit_per_night",
            //                                     "fixedCharge": 39.839999999999996,
            //                                     "description": "<ul>\r\n<li>Luxurious Room</li>\r\n<li>Breathtaking Views</li>\r\n<li>Coffee and Tea Machine</li>\r\n</ul>",
            //                                     "name": "Deluxe Room",
            //                                     "images": {
            //                                         "big": "https://cdn1.oci.nor1uat.com/room-images/h-1214/009223/big/00142248.jpg",
            //                                         "small": "https://cdn1.oci.nor1uat.com/room-images/h-1214/009223/small/00142248.jpg"
            //                                     },
            //                                     "savings": 6.72,
            //                                     "offerId": "93176A40-8143-4748-9867-E8CAB5DFDE85"
            //                                 },
            //                                 {
            //                                     "roomTypeCode": [
            //                                         "JSUI"
            //                                     ],
            //                                     "price": {
            //                                         "amount": 23.22,
            //                                         "currency": "USD"
            //                                     },
            //                                     "chargeFrequency": "per_unit_per_night",
            //                                     "fixedCharge": 69.66,
            //                                     "description": "<ul>\r\n<li>Balcony</li>\r\n<li>Coffe and Tea Machine</li>\r\n<li>King Sized Bed</li>\r\n</ul>",
            //                                     "name": "Junior Suite",
            //                                     "images": {
            //                                         "big": "https://cdn1.oci.nor1uat.com/room-images/h-1214/009223/big/00142249.jpg",
            //                                         "small": "https://cdn1.oci.nor1uat.com/room-images/h-1214/009223/small/00142249.jpg"
            //                                     },
            //                                     "savings": 11.78,
            //                                     "offerId": "7BFF5BDA-C3E1-4DF8-AF4B-75381891ABE8"
            //                                 },
            //                                 {
            //                                     "roomTypeCode": [
            //                                         "SUI"
            //                                     ],
            //                                     "price": {
            //                                         "amount": 51.44,
            //                                         "currency": "USD"
            //                                     },
            //                                     "chargeFrequency": "per_unit_per_night",
            //                                     "fixedCharge": 154.32,
            //                                     "description": "<ul>\r\n<li>Ocean View</li>\r\n<li>Extra Large TV</li>\r\n<li>Coffee and Tea Machine</li>\r\n</ul>",
            //                                     "name": "Suite",
            //                                     "images": {
            //                                         "big": "https://cdn1.oci.nor1uat.com/room-images/h-1214/009223/big/00142250.jpg",
            //                                         "small": "https://cdn1.oci.nor1uat.com/room-images/h-1214/009223/small/00142250.jpg"
            //                                     },
            //                                     "savings": 28.56,
            //                                     "offerId": "C52D8877-F86C-4522-AF06-78C48D2029FB"
            //                                 }
            //                             ]
            //                         }
            //                     ]
            //                 }
            //             ]
            //         }
            //     },
            //     "statusCode": 200
            // }

            const state = getState();

            const { appSessionToken, isLoggedIn } = state.appConfigSlice;
            const { currentGuestDetails } = state.guestDetailsSlice;
            const { isBookingFound, bookingData } = state.checkInSlice.bookingStatus;

            let reservationNumber, arrivalDate;
            if (isLoggedIn) {
                reservationNumber = currentGuestDetails.reservationNumber;
                arrivalDate = currentGuestDetails.checkInDate?.split("T")[0];
            } else if (isBookingFound) {
                reservationNumber = bookingData.reservationNumber;
                arrivalDate = bookingData.checkinDate;
            }

            console.log("bookingData", bookingData)
            
            const response = await clientConfigPath.post('/nor1/upsells/fetch', {
                header: {
                    sessionToken: appSessionToken
                },
                payload: {
                    reservationId: reservationNumber,
                    arrivalDate
                }
            });

            // console.log("response", response.data);

            const items = response?.data?.payload?.data?.items ?? [];
            const adhocGroupedList = {};
            items.forEach((event) => {
                groupAdhocEventByCategory(event, adhocGroupedList, BEFORE_PRE_CHECK_IN);
            })
            dispatch(setAdhocWidgetData(adhocGroupedList));

        } catch (error) {
            console.log('Adhoc fetching error', error);
        } finally {
            
        }
    }
}

export const applyAdhochNor1 = (offerId) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const { appSessionToken, isLoggedIn } = state.appConfigSlice;
            const { currentGuestDetails } = state.guestDetailsSlice;
            const { isBookingFound, bookingData } = state.checkInSlice.bookingStatus;

            let reservationNumber = null;
            if (isLoggedIn) {
                reservationNumber = currentGuestDetails.reservationNumber;
            } else if (isBookingFound) {
                reservationNumber = bookingData.reservationNumber;
            }

            const response = await clientConfigPath('nor1/upsells/apply', {
                header: {
                    sessionToken: appSessionToken
                },
                payload: {
                    reservationId: reservationNumber,
                    arrivalDate: currentGuestDetails.checkInDate?.split("T")[0],
                    offerId: offerId
                }
            })

            if(response?.data?.header?.status?.code == "SUCCESS"){
                return { status: true, message: response?.data?.header?.status?.msg }
            } else {
                return { status: false, message: response?.data?.header?.status?.msg }
            }
            
        } catch (error) {
            const errorMessage = error?.response?.data?.header?.status?.msg || error?.message || "Something went wrong";
            return { status: false, message: errorMessage }
            
        }
    }
}

